import { inject, Injectable } from '@angular/core';
import { Socket, io } from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/auth.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { UiUtilsService } from './UiUtils.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class WebSocketService {
  private client!: Socket;
  private readonly uiUtils = inject(UiUtilsService);
  private readonly translateService = inject(TranslateService);

  public readonly webSocketJobCounter = new BehaviorSubject<number>(0);
  public readonly webSocketJobCounterLimit = new BehaviorSubject<number>(0);
  public readonly webSocketFailedJobCounter = new BehaviorSubject<number>(0);

  constructor(private readonly authService: AuthService) {}

  initializeConnection() {
    this.client = io(environment.webSocketUrl, {
      extraHeaders: {
        Authorization: `Bearer ${this.authService.getAuthenticatedUser()}`,
      },
    });
  }

  listen(eventName: string) {
    return new Observable((subscriber) => {
      this.client.on(eventName, (data) => subscriber.next(data));
    });
  }

  closeConnection() {
    if (this.client && this.client.active) {
      this.client.disconnect();
    }
  }

  getClient() {
    return this.client;
  }

  isClientActive() {
    return this.client.active;
  }

  updateWebSocketJobCounter() {
    if (this.webSocketJobCounter.value && this.webSocketJobCounter.value > 0)
      this.webSocketJobCounter.next(this.webSocketJobCounter.value + 1);
    else this.webSocketJobCounter.next(1);
  }

  updateWebSocketJobFailedCounter() {
    if (this.webSocketFailedJobCounter.value && this.webSocketFailedJobCounter.value > 0)
      this.webSocketFailedJobCounter.next(this.webSocketFailedJobCounter.value + 1);
    else this.webSocketFailedJobCounter.next(1);
  }

  setWebSocketJobCounterLimit(limit: number) {
    this.webSocketJobCounterLimit.next(limit);
  }
}
